import './style/index.js';

import _SelectInput from './SelectInput';

export type { SelectInputProps } from './SelectInput';
export * from './type';

export const SelectInput = _SelectInput;
export default SelectInput;
